// extracted by mini-css-extract-plugin
export default {"avatarContainer":"WEcYrCZgJ7DHdu5VMVNc","center":"iBB4hUB1_Wx3Dt0l3hIN","statsRecruiters":"FAWoSjQST2u33rolqFeQ","extraContent":"Al8chkDsJX3gtSQkW6EE"};